import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { subscribe } from "../lib/api";
import { Reveal } from "../lib/ui";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribe(email);
      toast.success("You're on the list.", { description: "Batch drops and COA updates headed your way." });
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter" className="bg-rust px-6 py-24 text-cream md:px-12 md:py-32">
      <div className="mx-auto max-w-[1500px]">
        <Reveal>
          <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr] lg:items-end">
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.35em] text-cream/70">[ The Inner Circle ]</p>
              <h2 className="mt-6 font-display text-5xl leading-[0.88] tracking-tighter md:text-7xl">
                Join the<br />inner circle.
              </h2>
            </div>
            <form onSubmit={submit} className="w-full">
              <label className="font-mono text-[11px] uppercase tracking-[0.2em] text-cream/70">Email Address</label>
              <div className="mt-3 flex border-b-2 border-cream/40 focus-within:border-cream">
                <input
                  data-testid="newsletter-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="lab@institution.edu"
                  className="w-full bg-transparent py-3 font-body text-lg text-cream placeholder-cream/40 outline-none"
                />
                <button
                  data-testid="newsletter-submit"
                  type="submit"
                  disabled={loading}
                  className="group flex items-center gap-2 py-3 font-mono text-xs uppercase tracking-[0.2em] disabled:opacity-50"
                >
                  {loading ? "..." : "Join"}
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
                </button>
              </div>
            </form>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
